import React, { useState, useEffect } from 'react';
import { ArrowUpOutlined, DoubleRightOutlined} from '@ant-design/icons';

const ScrollToTopButton = () => {
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        calculateScrollValue();
        window.addEventListener('scroll', calculateScrollValue);
        return () => {
            window.removeEventListener('scroll', calculateScrollValue);
        };
    }, []);

    const calculateScrollValue = () => {
        const scrollTop = document.documentElement.scrollTop;
        const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const progress = (scrollTop / windowHeight) * 100;
        setScrollProgress(progress);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const buttonStyles = {
        position: 'fixed',
        bottom: '20px',
        right: '10px',
        height: '40px',
        width: '40px',
        display: scrollProgress > 0 ? 'grid' : 'none',
        placeItems: 'center',
        borderRadius: '50%',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
        // background: `conic-gradient(#03cc65 ${scrollProgress}%, #FFFFFF ${scrollProgress}%)`,
        // border: '2px solid #03cc65'
        background: `conic-gradient(rgb(73, 114, 144) ${scrollProgress}%, rgb(255, 255, 255) ${scrollProgress}%)`,
border: `2px solid ${scrollProgress > 50 ? 'rgb(73, 114, 144)' : 'rgb(150, 150, 150)'}`,
    };

    const iconStyles = {
        display: 'grid',
        placeItems: 'center',
        height: 'calc(100% - 10px)',
        width: 'calc(100% - 10px)',
        backgroundColor: '#ffffff',
        borderRadius: '50%',
        fontSize: '22px',
        color: 'rgb(1 31 53)',
        transform: 'rotate(-90deg)',
    };

    return (
        <div style={buttonStyles} onClick={scrollToTop}>
            {/* <span style={iconStyles}><ArrowUpOutlined /></span> */}
            <span style={iconStyles}><DoubleRightOutlined /></span>
        </div>
    );
};

export default ScrollToTopButton;
